module.exports = __webpack_public_path__ + "media/images/badge/prime-armi_secondary-932d49411258724aa3c643f80fd4b385.png";